export const defaultSupporterAllSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterAll;
export const defaultSupporterOpenAddSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterOpenAdd;
export const defaultSupporterOpenEditSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterOpenEdit;
export const defaultSupporterSelectedSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterSelected;
export const defaultSupporterSearchSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterSearch;
//
export const defaultSupporterInfoSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterInfo;
export const defaultSupporterTypeSelector = (state) =>
  state?.defaultSupporterReducer?.defaultSupporterType;
